<template>
    <div>
        <div class="text-center">
            <img src="/img/logo_login.png" class="standalone-logo" />
        </div>
        <form @submit.prevent="login" class="mt-2">
            <b-input-group class="mb-4">
                <b-input-group-prepend>
                    <b-input-group-text>
                        <i class="icon-user"></i>
                    </b-input-group-text>
                </b-input-group-prepend>
                <input
                    name="email"
                    v-validate="'required'"
                    data-vv-as="Email"
                    class="form-control"
                    placeholder="Email"
                    v-model="email"
                />
                <div v-show="errors.has('email')" class="validation-message text-danger">
                    {{ errors.first('email') }}
                </div>
            </b-input-group>
            <b-input-group class="mb-4">
                <b-input-group-prepend>
                    <b-input-group-text>
                        <i class="icon-lock"></i>
                    </b-input-group-text>
                </b-input-group-prepend>
                <input
                    type="password"
                    class="form-control"
                    :placeholder="$t('loginPage.password')"
                    v-model="password"
                    name="password"
                    v-validate="'required'"
                    :data-vv-as="$t('loginPage.password')"
                />
                <div v-show="errors.has('password')" class="validation-message text-danger">
                    {{ errors.first('password') }}
                </div>
            </b-input-group>
            <vue-recaptcha
                :sitekey="CONSTANTS.GG_RECAPCHA_KEY"
                :loadRecaptchaScript="true"
                @verify="onVerify"
            />
            <b-button
                block
                type="submit"
                :disabled="!enableButton"
                variant="primary"
                class="px-4 mt-2"
                >{{ $t('loginPage.login') }}</b-button
            >
        </form>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import VueRecaptcha from 'vue-recaptcha';
import CONSTANTS from '@/constants';
export default {
    name: 'Login',
    data() {
        return {
            email: '',
            password: '',
            enableButton: false,
            CONSTANTS
        };
    },
    components: { VueRecaptcha },
    methods: {
        ...mapActions({
            actionLogin: 'auth/actionLogin',
            // getVerifyCode: 'auth/getVerifyCode',
            createAuditByUser: 'user/createAuditByUser',
            getCurrentUserDetail: 'auth/getCurrentUserDetail'
        }),
        async login() {
            const result = await this.$validator.validateAll();
            if (result) {
                const { email, password } = this;
                try {
                    await this.actionLogin({ email, password });
                    await this.getCurrentUserDetail();
                    this.$emit('loginSuccess', true);
                    this.createAuditByUser({ content: 'Đăng nhập hệ thống' });
                    this.$toaster.success(this.$t('loginPage.loginSuccessMsg'));
                } catch (error) {
                    this.$toaster.error(this.$t('loginPage.loginErrorMsg'));
                }
            }
        },
        onVerify(data) {
            if (data) this.enableButton = true;
        }
        // async getCodeFromMail() {
        //     const result = await this.$validator.validateAll();
        //     if (result) {
        //         const { email } = this;
        //         try {
        //             await this.getVerifyCode({ email });
        //             this.$toaster.success(`Hệ thống đã gửi mã xác thực qua email ${email}`);
        //         } catch (error) {
        //             this.$toaster.error(this.$t('loginPage.loginErrorMsg'));
        //         }
        //     }
        // }
    }
};
</script>
